// styled
import styled from "styled-components";

// icon renderer
import { renderIcon } from "utils/helpers/typeKitchen";

// components
import { IconButton } from "components/ui-kit/buttons/IconButton";

// icons
import { Add as AddIcon } from "@mui/icons-material";

// original components
import { components } from "react-select";

const Option = ({ data, innerProps, selectOption, isDisabled, children, selectProps: { onMenuClose } }) => {

  const handleClick = (shouldCloseMenu) => () => {
    selectOption({ ...data });
    if (shouldCloseMenu) {
      onMenuClose();
    }
  }

  const props = {
    ...innerProps,
    onClick: handleClick(true),
  }

  return !isDisabled && (
    <StyledOption>
      <div {...props}>
        <img src={renderIcon(data.restaurant)} />
        {children}
      </div>
      <IconButton
        icon={<AddIcon />}
        onClick={handleClick(false)}
      />
    </StyledOption>
  );
}

const ValueContainer = ({ children, getStyles, ...props }) => (
  <components.ValueContainer
    {...props}
    getStyles={(key, props) => ({
      ...getStyles(key, props),
      height: 100,
      minHeight: 100,
      maxHeight: 100,
      overflowY: "auto",
    })}
  >
    {children}
  </components.ValueContainer>
);

const MultiValueLabel = ({ data, children }) => (
  <StyledMultiValueLabel>
    <img src={renderIcon(data.restaurant)} />
    {children}
  </StyledMultiValueLabel>
);

const Menu = (props) => (
  <StyledMenuWrapper>
    <components.Menu {...props} />
  </StyledMenuWrapper>
);

const StyledOption = styled.div`
    &, & > div {
      display: flex;
      align-items: center;

      & img {
        width: 28px;
        padding-right: 8px;
      }
    }

    & > div {
      height: 100%;
    }

    cursor: pointer;
    justify-content: space-between;
    padding: 0 8px;
    height: 32px;
`;

const StyledMultiValueLabel = styled.div`
    display: flex;
    padding: 4px 8px 4px 8px;

    & > img {
        width: 28px;
        padding-right: 8px;
    }
`;

const StyledMenuWrapper = styled.div`
    position: fixed;
    z-index: 9999;
    width: 350px;
`;

export default {
  Option,
  ValueContainer,
  MultiValueLabel,
  Menu,
};
